export function capitalizeFirstLetter(str: string) {
  return str.toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
}
